import CaptchaGenStatTableService from 'app/admin/captchagenstat/service/CaptchaGenStatTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'captchaGenStatTable',
	text: 'Captcha Generation Stat',
	topic: 'captchaGenStat',
	service: CaptchaGenStatTableService,
	icon: 'person',
	editFormState: item => `/captchagenstat/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh'/*, 'new'*/],
	filterFields: [],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'profileNames',
			text: 'Profile Names',
			textKey: 'profileNames',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'captchaTypeEngineName',
			text: 'Captcha Type Engine Name',
			textKey: 'captchaTypeEngineName',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'numberOfGenerated',
			text: 'Number Of Generated',
			textKey: 'numberOfGenerated',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'minimumGenerationTime',
			text: 'Minimum Generation Time',
			textKey: 'minimumGenerationTime',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'averageGenerationTime',
			text: 'Average Generation Time',
			textKey: 'averageGenerationTime',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'maximumGenerationTime',
			text: 'Maximum Generation Time',
			textKey: 'maximumGenerationTime',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function CaptchaGenStatTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('captchaGenStatTable', reducer('captchaGenStatTable'))(CaptchaGenStatTable);
